import { connect } from "react-redux";
import get from "lodash/get";

import {
  setBaselayer as onSetBaselayer,
  setOverlayers as onSetOverlayers,
  setZoom as onSetZoom,
  setMapCenter as onSetMapCenter,
  setMapBounds as onSetMapBounds,
  viewCustomMap as onViewCustomMap,
  setSearchLocation as onSetSearchLocation,
} from "../../actions/mapBaseLayerControlAction";

const mapStateToProps = (state) => ({
  mapBaseLayerDataState: state.mapBaseLayer.dataState,
  mapBaseLayer: get(state, ["mapBaseLayer", "baseLayer"], {}),
  mapOverlayers: get(state, ["mapBaseLayer", "overlayers"], {}),
  zoom: get(state, ["mapBaseLayer", "zoom"], 10),
  mapCenter: get(state, ["mapBaseLayer", "mapCenter"], []),
  mapBounds: get(state, ["mapBaseLayer", "mapBounds"], null),
  searchMapMarkerLocation: get(state, ["mapBaseLayer", "searchMapMarkerLocation"], null),
  isViewCustomMap: get(state, ["mapBaseLayer", "isViewCustomMap"], false),
});

const mapDispatchToProps = {
  onSetBaselayer,
  onSetOverlayers,
  onSetZoom,
  onSetMapCenter,
  onSetMapBounds,
  onViewCustomMap,
  onSetSearchLocation,
};

const withMapControl = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withMapControl };
